export const AUTH_HEADER = 'Authorization';
export const TOKEN_NAME = 'currentToken';
